import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import { isStandalone } from '@/utils/platform/isStandalone';
import '@picsart/design-system/foundation.css';

import '@/utils/dev/logger';
import useStyles from './styles';

export const App = () => {
  useStyles();

  const isOpen = useOpen();
  const isReady = isOpen || isStandalone();

  if (!isReady) {
    return null;
  }

  return <AppContent />;
};

export default App;
